import hive from '@assets/js/hive';

const videojs = process.client ? window.videojs : () => {};

const getCookie = function(cname) {
  if (process.client && document.cookie) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
  }

  return '';
};

export default class PlayerCreator {
  constructor(elementId) {
    this.elementId = elementId;
    this.player = null;
    this.src = '';
    this.time = 0;
  }

  start(src) {
    this.src = src;
    let fullscreenToggle = false;
    // if (!videojs || typeof videojs !== 'function') {
    //   return;
    // }
    if (videojs && videojs.browser && videojs.browser.IE_VERSION) {
      fullscreenToggle = !!videojs.browser.IE_VERSION;
    }
    const player = videojs(this.elementId, {
      autoplay: 'any',
      controlBar: {
        // IE 使用自带的全屏按钮，其他浏览器使用定制的全屏按钮，因为自带的全屏不支持弹幕全屏
        fullscreenToggle
      }
    });
    player.src({
      src
    });

    // player.on('loadstart', function() {
    //   console.log('player3 开始请求数据'); // 1
    // });
    player.on('durationchange', () => {
      if (this.time) {
        hive.send('010012004', {
          durationchange: new Date().getTime() - this.time,
          pc: 1,
          lang: getCookie('i18n_redirected')
        });
      }
    });
    // player.on('firstplay', function() {
    //   console.log('player3 firstplay'); // 3(点击播放)
    // });
    // player.on('play', function() {
    //   console.log('player3 视频开始播放'); // 4
    // });
    // player.on('waiting', function() {
    //   console.log('player3 等待数据'); // 5
    // });
    // player.on('loadedmetadata', function() {
    //   console.log('player3 获取资源长度完成 '); // 6 暂停后播放不触发
    // });
    // player.on('loadeddata', function() {
    //   console.log('player3 loadeddata'); // 7 暂停后播放不触发
    // });
    // player.on('canplay', function() {
    //   console.log('player3 canplay'); // 8
    // });
    // player.on('playing', function() {
    //   console.log('player3 视频播放中'); // 9
    // });
    // player.on('canplaythrough', function() {
    //   console.log('player3 视频源数据加载完成'); // 10
    // });

    player.on('error', function() {
      hive.send('010012004', {
        playererror: 'error',
        pc: 1,
        lang: getCookie('i18n_redirected')
      });
    });
    player.on('stalled', function() {
      // 当浏览器试图获取媒体数据但数据不可用时激发。
      hive.send('010012004', {
        playererror: 'stalled',
        pc: 1,
        lang: getCookie('i18n_redirected')
      });
    });
    player.on('suspend', function() {
      // 当浏览器故意不获取媒体数据时激发。
      hive.send('010012004', {
        playererror: 'suspend',
        pc: 1,
        lang: getCookie('i18n_redirected')
      });
    });

    player.ready(() => {
      this.time = new Date().getTime();
      const playPromise = player.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }
    });
    this.player = player;
  }

  switch(src) {
    this.src = src;
    this.player.src({
      src,
      type: 'application/x-mpegURL'
    });

    const playPromise = this.player.play();
    this.time = new Date().getTime();
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => {});
    }
  }

  reconnect() {
    const src = this.src;
    this.destroy();
    this.start(src);
  }

  play() {
    // 好像不会走这里
    this.time = new Date().getTime();
    const playPromise = this.player.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => {});
    }
  }

  pause() {
    this.player.pause();
  }

  trigger() {
    if (this.player.paused()) {
      this.play();
    } else {
      this.pause();
    }
  }

  destroy() {
    console.log('destroy player');
    this.player && this.player.dispose();
    this.player = null;
    this.src = '';
  }
}
